import { ReceivingRouteService } from 'common/data';
import { findParams } from 'core/utils';
import { BaseService } from 'core/services';
import { sourceOfChange } from 'common/constants';

class ReceivingService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new ReceivingRouteService());
	}

	find = filter => {
		const url = this.routeService.find(filter);
		return this.apiClient.post(url, findParams(filter));
	};

	approve = (id, sourceOfChange) => {
		const url = this.routeService.approve(id, sourceOfChange);
		return this.apiClient.put(url);
	};
}

export default ReceivingService;



// WEBPACK FOOTER //
// ./src/common/data/services/ReceivingService.js